SectionProfile.Event.Processing = Class(
	/**
	 * @lends {SectionProfile.Event.Processing#}
	 */
	{
		__NAME: 'SectionProfile.Event.Processing',
		bodyClass: 'small-nav grey hide-tablet-footer',
		name: 'team-processing',
		TOP_BAR: true,

		route(){
			PARENT.route();
			this.paymentId = Number(this.url.get.v('id'));
			this._gtagPricing = D.gtag.Pricing.getStored(String(this.paymentId));
		},

		_draw() {
			this.node = mkE({
				tag: 'div',
				id: 'profile-team-processing',
				els: [
					this._paymentProcess = new T.ProcessPayment(this.paymentId, this._onSuccess, this._onFailure, this.apiCall),
				]
			}).append(this._content);
			mkE({
				tag: 'div',
				className: 'container purchase-disclaimer centered',
				els: [
					{
						tag: 'div',
						className: 'disclaimer',
						els: [
							D.Lang.get('profile.team.purchase.receiver'),
							{
								tag: 'br'
							},
							D.Lang.get('profile.team.purchase.address')
						]
					}
				]
			}).append(this._mainNode);
		},

		_ready() {
			this._drawSidebar({purchase: true});
		},

		onShow() {
			this._paymentProcess.onShow();
		},

		_onSuccess() {
			if (this._gtagPricing) {
				this._gtagPricing.send('purchase');
				D.gtag.Pricing.removeStored(String(this.paymentId));
			}
			setTimeout(() => {
				window.location.href = D.url('profile/event/' + this.eventSlug);
			}, 2500);
		},

		_onFailure() {
			setTimeout(() => {
				window.location.href = D.url('profile/event/' + this.eventSlug + '/create?payment-failed');
			}, 2500);
		}
	},
	SectionProfile.EventBase
);
